import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../Icon';

const EDSvg = lazy(() => import('./ED'));

const ED = ({ color, size = 'medium', ...props }) => {
  return (
    <Icon viewBox="0 0 64 64" size={size} color={color} {...props}>
      <Suspense fallback={null}>
        <EDSvg />
      </Suspense>
    </Icon>
  );
};

ED.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  viewBox: PropTypes.string,
};

export default ED;
